<template>
  <div>
    <vx-card title="" :is-filter="true" class="mb-8" :init-collapsed="true" :collapse-action="true" @keyup.enter="loadApiKeys(1, null, true)">
      <template slot="actions">
        <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-plus" size="small" @click="createApiKey">{{ $t('add_agent_api_key') }}</vs-button>
      </template>

      <div class="vx-row">
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <vs-input :placeholder="$t('title')" v-model="apiSearchParams.company_name" class="w-full"/>
        </div>
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <v-select :options="activeStatusOptions" :reduce="label => label.value" :placeholder="$t('is_active')" v-model="apiSearchParams.status" class="mb-4 md:mb-0" />
        </div>
      </div>

      <template slot="footer">
        <vs-button color="success" type="filled" class="w-full" @click.prevent="loadApiKeys(1, null, true)" v-text="$t('search')"></vs-button>
      </template>
    </vx-card>

    <vx-card id="apiKeyDataContainer" :title="$t('api_key')" class="mb-8 vs-con-loading__container">
      <template slot="actions">
        <shared-management-tab-nav></shared-management-tab-nav>
      </template>

      <vs-table hover-flat v-if="apiKeys && apiKeys.length" :data="apiKeys">
        <template slot="thead">
          <vs-th v-text="$t('no')"></vs-th>
          <vs-th v-text="$t('company_name')"></vs-th>
          <vs-th v-text="$t('token')"></vs-th>
          <vs-th class="text-center" v-text="$t('status')"></vs-th>
          <vs-th class="text-center" v-text="$t('action')"></vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="key" v-for="(tr, key) in data">
            <vs-td v-text="tr.count"></vs-td>
            <vs-td v-text="tr.company_name"></vs-td>
            <vs-td>
              <badge-clipboard :text="tr.token"></badge-clipboard>
            </vs-td>
            <vs-td class="text-center">
              <badge-enabled :enabled="tr.is_active == 1"></badge-enabled>
            </vs-td>
            <vs-td class="text-center">
              <div class="flex justify-center">
                <vs-button color="primary" type="border" icon-pack="feather" icon="icon-edit" size="small" @click.prevent="editApiKey(tr.id)"></vs-button>&nbsp;
                <vs-button color="danger" type="filled" icon-pack="feather" icon="icon-trash-2" size="small" @click.prevent="deleteApiKey(tr.id)"></vs-button>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <vs-alert v-else class="flex justify-center p-0 h-auto" color="danger" active="true">
        <div v-text="$t('no_record')"></div>
      </vs-alert>

      <template slot="footer">
        <paginate
          :total="apiKeyPages"
          :itemPerPage="itemPerPage"
          :click-handler="loadApiKeys"
          v-model="initialPage"
          goto
        >
        </paginate>
      </template>
    </vx-card>

    <modal :title="$t('add_api_key')" :active.sync="modals.add" size="md">
      <div class="mb-3">
        <label class="vs-input--label" v-text="$t('company')"></label>
        <v-select :options="companyOptions" :reduce="label => label.value" :placeholder="$t('company')" v-model="apiKeyFormData.company_id" class="md:mb-0" />
        <validation-error :model-error="apiKeyFormErrors.company_id"></validation-error>
      </div>
      <div class="mb-3">
        <vs-input :label="$t('token')" :placeholder="$t('token')" v-model="apiKeyFormData.token" class="w-full"/>
        <validation-error :model-error="apiKeyFormErrors.token"></validation-error>
      </div>
      <vs-checkbox v-model="apiKeyFormData.is_active" class="mb-3"><span v-text="$t('is_active')"></span></vs-checkbox>

      <vs-divider></vs-divider>

      <div class="flex justify-end">
        <vs-button id="addApiKeyButton" color="primary" type="filled" @click.prevent="submitApiKey">{{ $t('save') }}</vs-button>
      </div>
    </modal>

    <modal :title="$t('edit_api_key')" :active.sync="modals.edit" size="md">
      <div id="apiKeyEditFormDataContainer" class="vs-con-loading__container">
        <div class="mb-3">
          <label class="vs-input--label" v-text="$t('company')"></label>
          <v-select :options="companyOptions" :reduce="label => label.value" :placeholder="$t('company')" v-model="apiKeyFormData.company_id" class="md:mb-0" />
          <validation-error :model-error="apiKeyFormErrors.company_id"></validation-error>
        </div>
        <div class="mb-3">
          <vs-input :label="$t('token')" :placeholder="$t('token')" v-model="apiKeyFormData.token" class="w-full"/>
          <validation-error :model-error="apiKeyFormErrors.token"></validation-error>
        </div>
        <vs-checkbox v-model="apiKeyFormData.is_active" class="mb-3"><span v-text="$t('is_active')"></span></vs-checkbox>

        <vs-divider></vs-divider>

        <div class="flex justify-end">
          <vs-button id="editApiKeyButton" color="primary" type="filled" @click.prevent="updateApiKey">{{ $t('save') }}</vs-button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import SharedManagementTabNav from '@/views/Shared/Management/TabNav'
import { activeStatusOptions } from '@/config/options'
import Paginate from '@/components/Paginate'
import Modal from '@/components/Modal'
import Pagination from '@/mixins/paginate'
import ApiKey from '@/models/ApiKey'

export default {
  name: 'Admin.Management.ApiKey',
  mixins: [Pagination],
  components: {
    SharedManagementTabNav,
    Paginate,
    Modal
  },
  data () {
    return {
      apiKeys: {},
      apiKeyPages: 0,
      apiKeyFormData: {
        company_id: '',
        token: '',
        is_active: 1
      },
      itemPerPage: null,
      apiKeyFormErrors: [],
      apiSearchParams: {
        company_name: '',
        status: ''
      },
      companyOptions: [],
      activeStatusOptions,
      modals: {
        add: false,
        edit: false
      }
    }
  },
  mounted () {
    this.loadApiKeys(this.initialPage, null)
  },
  watch: {
    'modals.add' (val) {
      if (!val) {
        this.resetApiKeyForm()
      }
    },
    'modals.edit' (val) {
      if (!val) {
        this.resetApiKeyForm()
      }
    }
  },
  methods: {
    async loadApiKeys (page = 1, itemPerPage = null, backToPageOne = false) {
      this.$vs.loading({container: '#apiKeyDataContainer'})
      if (itemPerPage !== null) {
        this.itemPerPage = itemPerPage
      } else if (this.itemPerPage !== null) {
        itemPerPage = this.itemPerPage
      }
      const response = await ApiKey.findAll({ ...this.apiSearchParams, page, itemPerPage })
      this.apiKeys = response.data.data
      this.apiKeyPages = response.data.meta.pagination.last_page
      this.companyOptions = response.data.meta.options.companies
      this.itemPerPage = response.data.meta.pagination.per_page
      if (backToPageOne === true) {
        this.initialPage = 1
      } else {
        this.initialPage = page
      }
      this.$vs.loading.close('#apiKeyDataContainer > .con-vs-loading')
    },
    async createApiKey () {
      const response = await ApiKey.getKey()
      this.apiKeyFormData.token = response.data

      this.modals.add = true
    },
    async submitApiKey () {
      this.$vs.loading({background: 'primary', color: '#fff', container: '#addApiKeyButton', scale: 0.45})

      try {
        const response = await ApiKey.store(this.apiKeyFormData)

        this.$swalHelper.success({
          title: this.$t('action_success'),
          text: this.$t(response.data),
          confirmButton: this.$t('confirm')
        })

        this.modals.add = false

        this.loadApiKeys()
        this.resetApiKeyForm()
      } catch (e) {
        const errors = this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
        this.apiKeyFormErrors = errors.validationErrors
      }

      this.$vs.loading.close('#addApiKeyButton > .con-vs-loading')
    },
    async editApiKey (id) {
      this.$vs.loading({container: '#apiKeyEditFormDataContainer'})

      try {
        this.modals.edit = true
        const response = await ApiKey.view({ id })
        this.apiKeyFormData = response.data.apiKey
      } catch (e) {
        this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
      }

      this.$vs.loading.close('#apiKeyEditFormDataContainer > .con-vs-loading')
    },
    async updateApiKey () {
      this.$vs.loading({background: 'primary', color: '#fff', container: '#editApiKeyButton', scale: 0.45})

      try {
        const response = await ApiKey.update(this.apiKeyFormData)

        this.$swalHelper.success({
          title: this.$t('action_success'),
          text: this.$t(response.data),
          confirmButton: this.$t('confirm')
        })

        this.modals.edit = false

        this.loadApiKeys()
        this.resetApiKeyForm()
      } catch (e) {
        const errors = this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
        this.apiKeyFormErrors = errors.validationErrors
      }

      this.$vs.loading.close('#editApiKeyButton > .con-vs-loading')
    },
    async deleteApiKey (id) {
      const confirm = await this.$swalHelper.warning({
        title: this.$t('are_you_sure_you_want_to_delete'),
        confirmButton: this.$t('execution'),
        cancelButton: this.$t('cancel')
      })

      if (confirm.value) {
        try {
          const response = await ApiKey.destroy({ id })

          this.$swalHelper.success({
            title: this.$t('action_success'),
            text: this.$t(response.data),
            confirmButton: this.$t('confirm')
          })

          this.loadApiKeys(1, null)
        } catch (e) {
          this.$swalHelper.displayCatchError({
            title: 'Error!',
            errorObject: e,
            confirmButton: this.$t('confirm')
          })
        }
      }
    },
    resetApiKeyForm () {
      this.apiKeyFormData = {
        company_id: '',
        token: '',
        is_active: 1
      }
      this.apiKeyFormErrors = []
    }
  }
}
</script>

<style lang="scss">
  #addApiKeyButton,
  #editApiKeyButton {
    .con-vs-loading {
      position: absolute !important;
    }
  }
</style>
